'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var closedByMergeTag = 'closed_by_merge';

var TicketInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TicketInfo, _Component);

  function TicketInfo(props) {
    (0, _classCallCheck3.default)(this, TicketInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TicketInfo.__proto__ || (0, _getPrototypeOf2.default)(TicketInfo)).call(this, props));

    _this.showMoreInsideThis = function () {
      return _this.setState(function (prevState) {
        return {
          showMoreInsideThis: !prevState.showMoreInsideThis
        };
      });
    };

    _this.state = {
      showMoreInsideThis: false
    };
    return _this;
  }

  (0, _createClass3.default)(TicketInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ticket = _props.ticket,
          isZendesk = _props.isZendesk;
      var showMoreInsideThis = this.state.showMoreInsideThis;


      var ticketAddress = 'https://kuna.zendesk.com/agent/tickets/' + ticket.id;

      var statusColor = void 0;
      switch (ticket.status) {
        case 'open':
          statusColor = 'red';
          break;
        case 'new':
          statusColor = 'yellow';
          break;
        case 'pending':
          statusColor = 'blue';
          break;
        default:
          // Gets Solved tickets
          statusColor = 'black';
      }

      var urgency = void 0;
      var urgencyColor = void 0;
      switch (ticket.priority) {
        case 'urgent':
          urgency = '❗';
          urgencyColor = 'red';
          break;
        case 'high':
          urgency = '⬆';
          urgencyColor = 'orange';
          break;
        case 'normal':
          urgency = '•';
          urgencyColor = 'black';
          break;
        case 'low':
          urgency = '⬇';
          urgencyColor = 'green';
          break;
        default:
          urgency = '⬍';
          urgencyColor = 'black';
      }

      var expansionSymbol = showMoreInsideThis ? '▴' : '▾';

      var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
        if (!string) {
          return '';
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
      };

      var ticketSubjectStyle = void 0;

      if (isZendesk) {
        ticketSubjectStyle = {
          width: '220px',
          overflow: 'hidden',
          'white-space': 'nowrap',
          display: 'inline-block',
          'text-overflow': 'ellipsis',
          'vertical-align': 'top'
        };
      }

      if (ticket.tags && ticket.tags.includes(closedByMergeTag)) {
        ticket.tags = ticket.tags.filter(function (item) {
          return item !== closedByMergeTag;
        });
        ticket.status = 'merged';
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { onClick: this.showMoreInsideThis },
          _react2.default.createElement(
            'span',
            { style: { color: statusColor } },
            '\u25C6 '
          ),
          _react2.default.createElement(
            'a',
            { target: '_blank', rel: 'noreferrer noopener', href: ticketAddress },
            ticket.id,
            ' '
          ),
          _react2.default.createElement(
            'span',
            { style: { color: urgencyColor } },
            urgency
          ),
          '- ',
          _react2.default.createElement(
            'span',
            { style: ticketSubjectStyle },
            ticket.subject
          ),
          ' ',
          expansionSymbol
        ),
        showMoreInsideThis && _react2.default.createElement(
          'div',
          { style: { 'white-space': 'pre-line', 'margin-left': '8px' } },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'b',
              null,
              capitalizeFirstLetter(ticket.status)
            ),
            ', ',
            _react2.default.createElement(
              'b',
              null,
              capitalizeFirstLetter(ticket.priority)
            ),
            ticket.priority ? ', ' : '',
            ticket.tags && ticket.tags.length > 0 && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Tags: '
              ),
              ticket.tags.join(', ') + '\n'
            )
          ),
          ticket.description
        )
      );
    }
  }]);
  return TicketInfo;
}(_react.Component), _class.propTypes = {
  ticket: _react.PropTypes.object,
  isZendesk: _react.PropTypes.bool
}, _temp);
exports.default = TicketInfo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TicketInfo/TicketInfo.js
 ** module id = 1387
 ** module chunks = 0
 **/